import React, { ReactElement, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import {
  Button, Col, FormGroup, Label, LoaderButton, Row, Textarea,
} from 'idsk-react-components';
import { BackButton, ConfirmModal } from 'slovlex-idsk-react-components';
import routes from '../../../routing/routes';
import { useSuccessMessageContext } from '../../../context/SuccessMessageContext';
import { useClient } from '../../../context/ClientStatusContext';
import useFieldErrorMessages from '../../useFieldErrorMessages';
import './odmietnutieGestora.scss';
import { rejectGestor } from '../../../client/pracovnyKrok/odmietnutieGestoraClient';

const OdmietnutieGestora = (): ReactElement => {
  const {
    type,
    year,
    index,
    pracovnyKrokId,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, pracovnyKrokId: string }>();

  const navigate = useNavigate();
  const { displaySuccess } = useSuccessMessageContext();

  const {
    getFieldErrorMessage,
    clearFieldErrorMessage,
  } = useFieldErrorMessages();

  const [dovodOdmietnutia, setDovodOdmietnutia] = useState<string>();

  const {
    wrapClient: odmietnuteGestoraClient,
    status: odmietnuteGestoraStatus,
  } = useClient(rejectGestor);

  const handleOdmietnuteGestora = async (): Promise<void> => {
    await odmietnuteGestoraClient(type, year, index, pracovnyKrokId, dovodOdmietnutia);
    navigate(routes.procesy.detail.withParams(type, year, index));
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  return (
    <div className="odmietnutie-gestora">
      <Row>
        <Col widthDesktop="two-thirds">
          <FormGroup
            error={!!getFieldErrorMessage('dovodOdmietnutia')}
          >
            <Label htmlFor="dovodOdmietnutia">Dôvod odmietnutia gestora</Label>
            <Textarea
              name="dovodOdmietnutia"
              expandHeight
              showRemaining
              rows={4}
              maxLength={2048}
              onChange={
                ({ target }) => {
                  setDovodOdmietnutia(target.value);
                  clearFieldErrorMessage('dovodOdmietnutia');
                }
              }
              error={getFieldErrorMessage('dovodOdmietnutia')}
            />
          </FormGroup>
        </Col>
      </Row>
      <div className="odmietnutie-gestora__buttons-container">
        <ConfirmModal
          question="Naozaj si prajete odmietnuť gestora?"
          description={'Po vykonaní tohto pracovného kroku sa proces vráti do štádia '
            + '"Priradenie gestora k vypracovaniu stanoviska". Nebude možné vykonávať pracovné kroky dostupné '
            + 'v aktuálnom štádiu a k materiálu sa uloží dôvod odmietnutia, ktorý bude viditeľný v detaile procesu.'}
          cancelButtonText="Nie"
          confirmButton={
            (
              <Button
                buttonStyle="action"
                size="large"
              >
                Áno
              </Button>
            )
          }
          openButton={(
            <LoaderButton
              className="odmietnutie-gestora__submit-button"
              size="large"
              loading={odmietnuteGestoraStatus.loading}
              disableOutsideClickWhileLoading
            >
              Vrátiť do štádia Priradenie gestora
            </LoaderButton>
          )}
          doAfterConfirm={handleOdmietnuteGestora}
        />
        <BackButton disabled={odmietnuteGestoraStatus?.loading} />
      </div>
    </div>
  );
};

export default OdmietnutieGestora;
